var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portfolioPage"},[_c('div',{staticClass:"section"},[_c('PortfolioOverview',{staticClass:"ppOverview",attrs:{"portfolio":_vm.portfolio}}),(!_vm.isMobile)?_c('ImportPortfolioDialog',{attrs:{"portfolio":_vm.portfolio}}):_vm._e()],1),_c('PortfolioList',{staticClass:"ppList",attrs:{"portfolio":_vm.portfolio}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }